export default __webpack_public_path__ + "static/media/hashnode.53bc70b9.svg";